import { Navigate, useParams, useSearchParams } from 'react-router-dom'
import { legacyToDesk } from '../../lib/deskPeriod'
import { deskPath } from '../../lib/deskTabs'

/** The old title page. Its body is now the desk's Revenue tab; old links keep
 *  working, with the old `range=` params translated to desk periods. */
export function VisitorsTitle() {
  const { pub = '' } = useParams()
  const [sp] = useSearchParams()
  return <Navigate to={deskPath(pub, 'revenue', legacyToDesk(sp).toString())} replace />
}
